export var Direction;
(function (Direction) {
    Direction[Direction["Down"] = 0] = "Down";
    Direction[Direction["Left"] = 1] = "Left";
    Direction[Direction["Right"] = 2] = "Right";
})(Direction || (Direction = {}));
export class DisclosureConfig {
    constructor(openTransX = 0, openTransY = 0, openRotation = 0, closeRotation = 0) {
        this.openTransX = openTransX;
        this.openTransY = openTransY;
        this.openRotation = openRotation;
        this.closeRotation = closeRotation;
    }
}
